// Mongolian numbers are 8 digits. People type spaces and dashes between digit groups
// and sometimes +976 in front, so those are dropped before the check.
// The server's utils/phone.js reads numbers the same way.
export const toMongolianPhone = (value) => {
  const phone = (typeof value === "string" ? value : "")
    .replace(/[\s-]/g, "")
    .replace(/^\+?976(?=\d{8}$)/, "");
  return /^\d{8}$/.test(phone) ? phone : null;
};
